import React from 'react';

interface Props {
  color?: string;
  className?: string;
  onClick?: () => void;
}

const MagnifyingGlass: React.FC<Props> = ({ color, className, onClick }) => {
  return (
    <button className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 24 24'
        strokeWidth={1.5}
        stroke={color || 'currentColor'}
        className='h-6 w-6'
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z'
        />
      </svg>
    </button>
  );
};

MagnifyingGlass.displayName = 'MagnifyingGlass';

export default MagnifyingGlass;
